export default __webpack_public_path__ + "static/media/PROCESSMETHOD_CNC_TURNING.bd8d45f0.png";